import React from "react";
const ConfidentialQuestionnaire = props => {
    return (
        <div>
            <h1>ConfidentialQuestionnaire</h1>
        </div>
    )
};

export default ConfidentialQuestionnaire;